export default {
    install: (vue) => {
        vue.prototype.$loctaionUrl = process.env.NODE_ENV === "development" ? 'http://api.njsimiao.com' : window.location.origin
        vue.prototype.$imgUrl = process.env.NODE_ENV === "development" ? '/prod-api' : '/prod-api'
    }
}